<div class="layout-footer">
  <a href="https://primeng.org" target="_blank" rel="noopener noreferrer" class="font-bold hover:underline">{{ copyrightText }}</a>
  <div class="flex justify-center gap-[1.5rem]">
    <!-- x -->
    <a href="https://www.x.com" target="_blank">
      <img src="assets/images/x.svg" alt="x" />
    </a>
    <!-- linkedin -->
    <a href="https://www.linkedin.com" target="_blank">
      <img src="assets/images/linkedin.svg" alt="linkedin" />
    </a>
    <!-- facebook -->
    <a href="https://www.facebook.com" target="_blank">
      <img src="assets/images/facebook.svg" alt="facebook" />
    </a>
  </div>
</div>
